// src/app/features/trade/durationProfit.js

export const DELIVERY_OPTIONS = [
  { key: "30s",  label: "30 seconds", seconds: 30,         profitPercent: 20 },
  { key: "60s",  label: "60 seconds", seconds: 60,         profitPercent: 30 },
  { key: "120s", label: "120 seconds", seconds: 120,       profitPercent: 40 },
  { key: "1h",   label: "1 hour",     seconds: 60 * 60,    profitPercent: 50 },
  { key: "12h",  label: "12 hours",   seconds: 12 * 60 * 60, profitPercent: 60 },
  { key: "1d",   label: "1 day",      seconds: 24 * 60 * 60, profitPercent: 70 },
  { key: "7d",   label: "7 days",     seconds: 7 * 24 * 60 * 60, profitPercent: 80 },
  { key: "15d",  label: "15 days",    seconds: 15 * 24 * 60 * 60, profitPercent: 90 },
  { key: "30d",  label: "30 days",    seconds: 30 * 24 * 60 * 60, profitPercent: 100 },
];

export function getOptionBySeconds(seconds) {
  const s = Number(seconds);
  return DELIVERY_OPTIONS.find((o) => o.seconds === s) || DELIVERY_OPTIONS[0];
}

// payoutMultiplier should represent "stake + profit" on net stake.
// Example: 20% profit => 1.20x
export function toPayoutMultiplier(profitPercent) {
  const p = Number(profitPercent);
  if (!Number.isFinite(p)) return 1;
  return 1 + p / 100;
}
